import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { ChevronDown } from "lucide-react";

export default function FaqPage() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { http.get("/public/property").then((r) => setData(r.data)); }, []);
  if (!data) return null;
  return (
    <div>
      <PublicHeader />
      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16">
        <div className="eyebrow mb-3">Guests ask</div>
        <h1 className="h1-hero text-5xl md:text-6xl mb-10">Frequently Asked</h1>
        <div className="space-y-3">
          {data.faqs.map((f, i) => (
            <div key={f.id} className="card" style={{ padding: 0 }}>
              <button onClick={() => setOpen(open === i ? null : i)} data-testid={`faq-toggle-${i}`}
                className="w-full flex items-center justify-between text-left p-5">
                <span className="font-serif text-xl">{f.question}</span>
                <ChevronDown size={20} style={{ transform: open === i ? "rotate(180deg)" : "none", transition: "transform .2s" }} />
              </button>
              {open === i && <div className="px-5 pb-5" style={{ color: "var(--muted)" }}>{f.answer}</div>}
            </div>
          ))}
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
